export const hasKey = (key: string, obj: Record<string, any>) =>
  Object.prototype.hasOwnProperty.call(obj, key)
